import { api } from "../../services/NetworkBase";

export async function GetOutsourcedAnalysisByCriteria(startDate, endDate, searchText,orderStatus) { 
  try {
    let response = await api
      .get(`vlp/outsourced-analysis?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&orderStatus=${orderStatus}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetOutsourcedAnalysisById(analysisId) {
  try {
    let response = await api.get(`vlp/outsourced-analysis/${analysisId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateOutsourcedAnalysis(analysis) {  
  try {
    let response = await api.put("vlp/outsourced-analysis", { json: analysis });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveOutsourcedAnalysis(analysis) {
  try {
    let response = await api.post("vlp/outsourced-analysis", { json: analysis });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteOutsourcedAnalysis(analysisId) {
  try {
    const encodedUrl = encodeURIComponent(analysisId);
    let response = await api
      .delete(`vlp/outsourced-analysis/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ApproveOutsourcedAnalysis(analysisId) {
  try {
    const encodedUrl = encodeURIComponent(analysisId);
    let response = await api
      .put(`vlp/outsourced-analysis/approve/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}


export async function ApproveMultipleOutsourcedAnalysis(ids) {
  try {
    let response = await api
      .put(`vlp/outsourced-analysis/approve/multiple`, { json: ids })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
